<template>
  <Modal :active="active" :close-disabled="removing" @close="emits('close')">
    <template #header>
      {{ $t("customFlows.removePageModal.title") }}
    </template>

    <template #body>
      {{ $t("customFlows.removePageModal.message") }}
    </template>

    <template #footer>
      <div class="buttons">
        <button
          class="button secondary"
          :disabled="removing"
          @click="emits('close')"
        >
          {{ $t("cancel") }}
        </button>
        <button
          class="button dangerous"
          :disabled="removing"
          @click="removePage"
        >
          {{ $t("customFlows.removePageModal.submit") }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Modal } from "@/components";
import { useRemoveFlowItemMutation } from "@/graphql/operations";

const props = defineProps({
  active: {
    type: Boolean,
    required: true,
  },
  pageId: {
    type: String,
    required: true,
  },
});

const emits = defineEmits(["close", "pageRemoved", "error"]);

const { executeMutation: deleteFlowItem } = useRemoveFlowItemMutation();
const removing = ref(false);
const removePage = async () => {
  if (removing.value) return;
  removing.value = true;
  try {
    const res = await deleteFlowItem({
      id: props.pageId,
    });
    if (res.error) {
      throw new Error(res.error.message);
    }
    emits("pageRemoved");
  } catch {
    emits("error");
  } finally {
    removing.value = false;
  }
};
</script>

<style lang="scss" scoped></style>
